import { Text } from "components/Text"
import {
  Accordion,
  AccordionContent,
  AccordionSummary,
} from "components/Accordion"
import { Separator } from "components/Separator"

export function AccordionSection({ label, children }) {
  return (
    <div className="space-y-5">
      <Accordion>
        <AccordionSummary>
          <Text className="text-primary-dark" variant="headline5">
            {label}
          </Text>
        </AccordionSummary>
        <AccordionContent>
          {(expanded) => (expanded ? children : null)}
        </AccordionContent>
      </Accordion>
      <Separator />
    </div>
  )
}
